import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ApplicationRef, TemplateRef, ViewChild, AfterViewInit   } from '@angular/core';
import { CifrasMensualesService } from '../../service/cifras-mensuales.service';
import { NotasService } from '../../service/notas.service';
import { Meta, Title } from '@angular/platform-browser';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { SeoService } from '../../service/seo.service';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { filter } from 'rxjs/operators';
import { HomeService } from '../../service/home.service';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css'],
  providers: [
		{
			provide: CarouselConfig,
			useValue: { interval: 5000, showIndicators: true }
		}
	]
})
export class IndexComponent implements OnInit, AfterViewInit {
   @ViewChild('template') content!: TemplateRef<any>;
    modalRef!: BsModalRef;
    cifras!: any[];
    notas!: any[];
    newstr: any;
    activo: any;
    RouteText : any;
    tituloseo: any;
    urlcanonicaseo: any;
    imagenseo: any;
    keywordsseo: any;
    descripcionseo: any;
    sliders: any;

    constructor(
        private _cifrasMensualesService: CifrasMensualesService,
        private _notasService: NotasService,
        private _urlcanonicaservice: UrlcanonicaService,
        private router: Router,
        private _seoService: SeoService,
        private meta: Meta,
        private title: Title,
        private _HomeService: HomeService,
        private update: SwUpdate,
        private appRef: ApplicationRef,
        private modalService: BsModalService
    ) {
      this.updateClient();
      this.checkUpdate();
      this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.RouteText = event;
        this.getSEO(event.url)
      });
    }


    mostrarBanner = false;
    ngOnInit(): void {
      this.getCarrusel();
      //this.getCifrasMensual();
      this.getNotas();

       const consentimiento = localStorage.getItem('cookies_aceptadas');
      if (!consentimiento) {
        this.mostrarBanner = true; 
      }
    }

    aceptarCookies() {
      localStorage.setItem('cookies_aceptadas', 'true');
      this.mostrarBanner = false;
    }


    ngAfterViewInit(): void {
      //this.openModal(this.content);
    }

    getCarrusel() {
      this._HomeService.getCarrusel().subscribe((resp: any) => {
        this.sliders = resp.sort((a:any, b:any) => a.orden - b.orden);
      });
    }

    //Replicar para todas las paginas Principales
    getSEO(page: string) {
      this._seoService.getSEO(page).subscribe((resp: any) => {
        if (resp != null) {
          this.tituloseo = resp.titulo;
          this.descripcionseo = resp.descripcion;
          this.urlcanonicaseo = resp.urlcanonica;
          this.imagenseo = resp.imagen;

          this._urlcanonicaservice.createCanonicalLink();
          this.title.setTitle(this.tituloseo)
          this.meta.updateTag({
            name: 'description',
            content: this.descripcionseo
          })

          this.meta.updateTag({
            property: 'twitter:card',
            content: 'summary'
          })
          this.meta.updateTag({
            property: 'twitter:site',
            content: '@fundacionbest'
          })
          this.meta.updateTag({
            property: 'twitter:title',
            content: 'Fundación BEST'
          })
          this.meta.updateTag({
            property: 'twitter:description',
            content: this.descripcionseo
          })
          this.meta.updateTag({
            property: 'twitter:image',
            content: this.imagenseo
          })

          this.meta.updateTag({
            property: 'og:url',
            content: 'https://fundacionbest.org.mx/servicios'
          })
          this.meta.updateTag({
            property: 'og:title',
            content: this.tituloseo
          })
          this.meta.updateTag({
            property: 'og:image',
            content: this.imagenseo
          })
          this.meta.updateTag({
            property: 'og:description',
            content: this.descripcionseo
          })
        }

      });
    }


    getCifrasMensual() {
        this._cifrasMensualesService.getCifrasMensuales().subscribe((resp: any) => {
          console.log(resp)
          //this.cifras = resp.slice(2);
        });
      }

    getNotas() {
        this._notasService.getNotasHome().subscribe((resp: any) => {
          console.log(resp)
          this.notas = resp;
        });
    }

    getNotaUrl(nota: any) {
        this.newstr = nota.urlNota.toLowerCase();
        this.newstr = this.newstr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        this.router.navigate(["/nota/" + nota.id + "/" + this.newstr]);
        // por si se necesita remplazar caractes especiales
        // this.newstr = this.newstr.replace(/[^\w\s]/gi, '');
    }

    getEmpleo(){
        this.router.navigate(['empleo']);
      }

    getQuienesSomos(){
        this.router.navigate(['quienes-somos']);
      }

    updateClient() {
      if (!this.update.isEnabled) {
        console.log('Not Enabled');
        return;
      }
      this.update.available.subscribe((event) => {
        console.log(`current`, event.current, `available `, event.available);
        if (confirm('Una nueva version del sitio')) {
          this.update.activateUpdate().then(() => location.reload());
        }
      });

      this.update.activated.subscribe((event) => {
        console.log(`current`, event.previous, `available `, event.current);
      });
    }

    checkUpdate() {
      this.appRef.isStable.subscribe((isStable) => {
        if (isStable) {
          const timeInterval = interval(8 * 60 * 60 * 1000);

          timeInterval.subscribe(() => {
            this.update.checkForUpdate().then(() => console.log('checked'));
            console.log('update checked');
          });
        }
      });
    }



    /*openModal(template: TemplateRef<any>) {
      console.log(template);
      this.modalRef = this.modalService.show(template);
    }*/ 

}

